import React from 'react';
import PropTypes from 'prop-types';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { withRouter } from "react-router-dom";
import { Icon, LinkText, Typography } from "../ecosystem";

const FavoriteDrSchedule = ({
    disableBookNow,
    isMobile,
    phone,
    scheduleUrl,
    showBookNow,
    showPhone,
    orientation = "vertical"
}) => {

    const favDrScheduleClasses = [
        'favorite-doctors-schedule-container',
        `favorite-doctors-schedule-container--${orientation}`
    ].join(' ');

    return (<div className={favDrScheduleClasses}>
        {showBookNow
            ? <LinkText
                to={{ pathname: scheduleUrl }}
                onClick={(e) => {
                    logUI("MBHWeb.UI.MyFavoriteProviders.ScheduleMoreLinkClicked.BookNow", new Date(), Tools.getURLPath());
                }}
                typographyType="body-02"
                disabled={disableBookNow}
                decorator="mobile"
                color={!isMobile ? "$color-primary-a2" : ""}
            >
                <div className="favorite-doctors-schedule__label">
                    <div className="favorite-doctors-schedule__label-icon"><Icon name="calendar" /></div>
                    Book Now
                </div>               
            </LinkText>
            : phone &&
                <LinkText
                    href={"tel:" + phone}
                    onClick={(e) => {
                        logUI("MBHWeb.UI.MyFavoriteProviders.ScheduleMoreLinkClicked.Schedule", new Date(), Tools.getURLPath());
                    }}
                    typographyType="body-02"
                    decorator="mobile"
                    color={!isMobile ? "$color-primary-a2" : ""}
                >
                    <div className="favorite-doctors-schedule__label">
                        <div className="favorite-doctors-schedule__label-icon"><Icon name="phone" /></div>
                        Schedule
                    </div>
                    {showPhone &&
                        <div className="favorite-doctors-schedule__phone">
                            <Typography type="body-01">{phone}</Typography>
                        </div>
                    }
                </LinkText>
        }
    </div>);
}

export default withRouter(FavoriteDrSchedule);


FavoriteDrSchedule.propTypes = {
    disableBookNow: PropTypes.bool,
    phone: PropTypes.string,
    scheduleUrl: PropTypes.string,
    showBookNow: PropTypes.bool,
    showPhone: PropTypes.bool,
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
}
